// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__HT7Uo","inner":"Form_inner__40cJx","range":"Form_range__3R5Em","name":"Form_name__1theS","actions":"Form_actions__6MmiR"};